import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import getForm from "lib/getForm";
import DocumentRequestFormSkeletton from "components/Form/DocumentRequestFormSkeletton";

const DocumentRequestForm = dynamic(
  () => import("components/Form/DocumentRequestForm"),
  {
    ssr: false,
  }
);

const FORM_IDS = {
  fr: "documents_request",
  en: "documents_request_en",
};

export default function DocumentRequest({ file }) {
  const [fields, setFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const formId = FORM_IDS[file.langcode] || FORM_IDS.fr;

  useEffect(() => {
    const controller = new AbortController();

    getForm(formId, true, controller.signal)
      .then((data) => {
        setFields(data);
        setIsLoading(false);
      })
      .catch(console.error);

    return () => controller.abort();
  }, []);

  return isLoading ? (
    <DocumentRequestFormSkeletton />
  ) : (
    <DocumentRequestForm
      id={formId}
      fields={fields}
      defaultValues={{ file_id: file.drupal_internal__fid }}
    />
  );
}
